import { Component, Input, NgZone, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { LoggerService } from "../../../../common/logging/logger.service";
import { ModalDialogComponent } from "../../../../common/modal/modalDialog.component";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import { TextColumnDefinition, ColumnDefinition } from "../../../../dashboardCommon/components/cardDetails/datatable.component";
import { SingleSummaryDetailKpiServiceHost } from "../../../../dashboardCommon/components/kpiServiceHostComponent";
import { ClientsWoBulletinsDetailService, ClientsWoBulletinsDetailServiceData } from "../../services/administrativeManagementDigitalizationKpi/clientsWoBulletinsDetail.service";
import { ImpersonationService } from "src/app/auth/apigee/impersonation.service";

export class ClientsWoBulletinsExtendedData {
    public office: number;
    public s1: number;
    public s2: number;
    public s3: number;
    public s4: number;

    constructor(office: number, s1: number, s2: number, s3: number, s4: number) {
        this.office = office;
        this.s1 = s1;
        this.s2 = s2;
        this.s3 = s3;
        this.s4 = s4;
    }
}

export class ClientsWoBulletinsExtendedDetailData {
    public columnDefinitions: ColumnDefinition[];
    public tabledata: any[][];

    constructor(columnDefinitions: ColumnDefinition[], tabledata: any[][]) {
        this.columnDefinitions = columnDefinitions;
        this.tabledata = tabledata;
    }
}

@Component({
    selector: 'client-wo-bulletins-extended-kpi-service-host',
    template: '<ng-content></ng-content>',
    standalone: false
})
export class ClientsWoBulletinsExtendedKpiServiceHostComponent extends SingleSummaryDetailKpiServiceHost<ClientsWoBulletinsDetailService, ClientsWoBulletinsDetailServiceData, ClientsWoBulletinsExtendedData, ClientsWoBulletinsExtendedDetailData>
    implements OnDestroy {
    public getClassName() { return "ClientsWoBulletinsExtendedKpiServiceHostComponent"; }

    private raasSubscription: Subscription;
    private officeSelectorSubscription: Subscription;
    @Input() public detailDialog: ModalDialogComponent;

    constructor(zone: NgZone, logger: LoggerService, private impersonationService: ImpersonationService,
        private officeSelectorService: OfficeSelectorService, summaryDetailService: ClientsWoBulletinsDetailService) {
        super(zone, logger, summaryDetailService);
        this.raasSubscription = this.impersonationService.impersonationChanged.subscribe(() => { this.resetSummary(); });
        this.officeSelectorSubscription = this.officeSelectorService.selectedOfficeUpdated.subscribe(() => { this.resetSummary(); });
    }

    protected processSummaryData(data: ClientsWoBulletinsDetailServiceData): ClientsWoBulletinsExtendedData {
        return new ClientsWoBulletinsExtendedData(
            data.clients.length,
            (data.clients.filter(x => x.centerSegment == "1") || []).length,
            (data.clients.filter(x => x.centerSegment == "2") || []).length,
            (data.clients.filter(x => x.centerSegment == "3") || []).length,
            (data.clients.filter(x => x.centerSegment == "4") || []).length,
        );
    }
    protected getDefaultSummaryData(): ClientsWoBulletinsExtendedData {
        return new ClientsWoBulletinsExtendedData(0,0,0,0,0);
    }


    protected extractUpdateTime(data: ClientsWoBulletinsDetailServiceData): Date {
        return data.updateTimestamp;
    }

    protected processDetailData(data: ClientsWoBulletinsDetailServiceData): ClientsWoBulletinsExtendedDetailData {

        if (data.clients) {
            let columnDefinitions = [
                new TextColumnDefinition("Cliente"),
                new TextColumnDefinition("Centro"),
                new TextColumnDefinition("Segmento")
            ];

            let tabledata = [];

            data.clients = data.clients.sort(function (a, b) {
                if (a.centerSegment > b.centerSegment) {
                    return 1;
                }
                if (a.centerSegment < b.centerSegment) {
                    return -1;
                }
                return 0;
            });

            for (let client of data.clients) {
                tabledata.push([
                    client.clientFiscalName,
                    client.centerCode,
                    client.centerSegment
                ]);
            }
            return new ClientsWoBulletinsExtendedDetailData(columnDefinitions, tabledata);
        }
        else return this.getDefaultDetailData();
    }

    protected getDefaultDetailData(): ClientsWoBulletinsExtendedDetailData {
        let columnDefinitions = [
            new TextColumnDefinition("Cliente"),
            new TextColumnDefinition("Centro"),
            new TextColumnDefinition("Segmento")
        ];

        return new ClientsWoBulletinsExtendedDetailData(columnDefinitions, []);
    }

    protected performDetailAction(): void {
        if (this.detailDialog) this.detailDialog.open();
    }

    public ngOnDestroy(): void {
        if (this.raasSubscription) this.raasSubscription.unsubscribe();
        if (this.officeSelectorSubscription) this.officeSelectorSubscription.unsubscribe();
    }
}
